import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import {
    EssentialityClaimChatApiSymbol,
    type IEssentialityClaimChatApi,
} from '@/domains/essentiality-claim/apis/essentiality-claim-chat-api';
import { EssentialityClaimChatApiImpl } from '@/domains/essentiality-claim/apis/essentiality-claim-chat-api-impl';

export const essentialityClaimModule = new ContainerModule((bind) => {
    bind<IEssentialityClaimChatApi>(EssentialityClaimChatApiSymbol)
        .to(EssentialityClaimChatApiImpl)
        .inSingletonScope();
});
